class FreeGoodies extends HTMLElement {
  constructor() {
    super();
    this.popup = this.querySelector(".goodies-popup");
    this.openPopup = this.querySelector(".js-open-goodie-popup");
    this.closePopup = this.querySelectorAll(".js-close-goodie-popup");
    this.addToCartButtons = this.querySelectorAll(".product-card--add-to-cart-button-simple");
    this.popupOverlay = this.querySelector(".goodies-overlay");

    this.isInDrawer = this.hasAttribute("rendered-in-drawer");
    this.cartDrawer = document.getElementById("Cart-Drawer");
  }

  get freeGoodieReached () {
    return this.hasAttribute('data-active');
  }

  get goodieInCart() {
    return this.hasAttribute('data-goodie-in-cart-id') ? this.getAttribute('data-goodie-in-cart-id') : undefined;
  }

  connectedCallback() {
    this.wacthGoodiesProgress();
    this.setupEventListeners();
  }

  setupEventListeners() {
    document.addEventListener('line-item:change:start', (event)=> {
      if(event.detail.quantity === '0' && event.detail.line_id === this.goodieInCart) {
        this.removeDiscountCode();
      }
    })
    if (this.openPopup) {
      this.openPopup.addEventListener('click', (event)=> this.openPopupHandler(event));
      this.closePopup.forEach(button => {
        button.addEventListener('click', (event)=> this.closePopupHandler(event));
      });
      this.addToCartButtons.forEach(button => {
        button.addEventListener('click',  async (event)=> this.addGoodieToCart(button, event));
      })
      document.addEventListener('keyup', (event)=> this.handleKeyUp(event));
    } else {
      document.removeEventListener('keyup', (event)=> this.handleKeyUp(event));
    }
  }

  openPopupHandler(event) {
    event.preventDefault();
    this.popup.classList.add('active');
    this.popupOverlay.classList.add('active');
  }

  closePopupHandler(event) {
    event.preventDefault();
    this.popup.classList.remove('active');
    this.popupOverlay.classList.remove('active');
  }

  handleKeyUp(event) {
    const charCode = event.code ? event.code.toUpperCase() : event.key.toUpperCase();
    if (charCode === 'ESCAPE') this.closePopupHandler(event);
  }

  async wacthGoodiesProgress() {
    if (!this.freeGoodieReached && this.goodieInCart) {
        await this.removeDiscountCode();
        await this.removeGoodieFromCart(this.goodieInCart); 
    }
  }
  
  async applyDiscount(code) {
    try {
      await fetch(`${window.Shopify.routes.root}discount/${code}`);
    } catch (error) {
      console.error(error);
    }
  }

  async removeDiscountCode() {
    try {
      await fetch(`${window.Shopify.routes.root}discount/CLEAR`);
    } catch (error) {
      console.error('Failed to clear discount:', error);
    }
  }

  renderToast(item){
    if(!item) return;
    if(!window.location.href.includes('/cart')) return;
    const { searchParams } = new URL(window.location.href);
    const stepParam = searchParams.get('step');
    const shouldProceed = (stepParam === null) || (parseInt(stepParam, 10) === 1);
    if(!shouldProceed) return

    const {featured_image, product_title} = item;
    let container = document.querySelector('.toast-container');
      if (!container) {
        container = document.createElement('div');
        container.className = 'toast-container';
        document.body.appendChild(container);
      }

      const toast = document.createElement('div');
      toast.className = 'toast';

      if (featured_image?.url) {
        const img = document.createElement('img');
        img.src = featured_image.url;
        img.alt = featured_image.alt || product_title;
        img.width = 50;
        img.height = 50;
        toast.appendChild(img);
      }
      
      const text = document.createElement('div');
      text.className = 'toast-text';

      const title = document.createElement('p');
      title.textContent = this.dataset.goodiesNotification || 'Geschenk zum Warenkorb hinzugefügt!';
      text.appendChild(title)

      const product = document.createElement('p');
      product.textContent = product_title;
      text.appendChild(product)

      toast.appendChild(text);
      container.appendChild(toast);

      setTimeout(() => {
        toast.classList.add('hide');
      }, 3000);
      setTimeout(() => {
        toast.remove();
      }, 3300)
  }

  async addGoodieToCart(button, event) {
    event.preventDefault();
    const code = button.dataset.code;
    const id = button.dataset.productId;

    if(this.goodieInCart) {
      await this.removeDiscountCode();
      await this.removeGoodieFromCart(this.goodieInCart); 
    }
    if (!code && !id) return;

    button.classList.add("loading");
    button.setAttribute("aria-disabled", true);
    this.popup.classList.remove("active");

    const url = `${window.Shopify.routes.root}cart/add.js`;
    const bodyRequest = {
      items: [
        {
          id: id,
          quantity: 1,
          properties: {
            _gift_product: true
          }
        }
      ],
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    }
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(bodyRequest)
    };

    try {
      if (this.isInDrawer) {
        this.cartDrawer.classList.add("loading");
      }

      await this.applyDiscount(code);
      const response = await fetch(url, config);
      const result = await response.json();
      
   
      this.renderContents(result);
    
      button.classList.remove("loading");
      button.removeAttribute("aria-disabled");
      if(response.ok && result && !this.isInDrawer) {
        const item = result.items[0];
        this.renderToast(item)
      }
    } catch (error) {
      console.error(error);
    } finally {
      if (this.isInDrawer) {
        this.cartDrawer.classList.remove("loading");
      }
    }
  }

  async removeGoodieFromCart(id) {
    const url = `${window.Shopify.routes.root}cart/update.js`;
    const bodyRequest = {
      updates: {
        [id]: 0
      },
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    }
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(bodyRequest)
    };

    try {
        const response = await fetch(url, config);
        const result = await response.json();
        this.renderContents(result);
      }
    catch (error) {
      console.error(error);
    }
  }

  getSectionsToRender() {
    return [
      this.isInDrawer
        ? {
            id: "Cart-Drawer",
            section: "cart-drawer",
            selector: ".cart-drawer",
          }
        : {
            id: "Cart",
            section: "main-cart",
            selector: ".thb-cart-form",
          },
      {
        id: "cart-drawer-toggle",
        section: "cart-bubble",
        selector: ".thb-item-count",
      },
    ];
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section => {
      if (!document.getElementById(section.id)) {
        return;
      }
      const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      if (typeof Cart !== 'undefined') {
        new Cart().renderContents(parsedState);
      }
    }));
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

if(!customElements.get('free-goodies')) {
  customElements.define('free-goodies', FreeGoodies)
}